// extracted by mini-css-extract-plugin
module.exports = {"Player":"wJvqL","Player__Iframe":"geLD9"};